import {
  type ConfigurationOperation,
  isLibraryInOut,
  isTemplateCreateOperation,
} from '@festina/configuration-general-types/configuration'
import type { ExcludeString } from '@festina-life/core'

import type { ConfigurationItem } from '../../../types/common'

export const getConfigurationItemType = (
  operation: ConfigurationOperation,
): ConfigurationItem => {
  const operationType = operation._type as ExcludeString<
    ConfigurationOperation['_type']
  >

  switch (operationType) {
    case 'AnnulOperation':
      return 'annulOperation'
    case 'EnumDefinitionCreateOperation':
      return 'enumDefinition'
    case 'EnumLiteralCreateOperation':
      return 'enumLiteral'
    case 'GlMapCreateOperation':
      return 'glMap'
    case 'GlMapHideOperation':
      return 'hideGlMap'
    case 'LargeOperation':
    case 'ParameterValueCreateOperation':
    case 'ParameterValueHideOperation':
      return 'parameterValue'
    case 'ParameterDefinitionCreateOperation':
      return 'parameterDefinition'
    case 'ParameterValueAmendOperation':
      return 'parameterValueAmendment'
    case 'ReconciliationSpecCreateOperation':
      return 'reconciliationSpec'
    case 'RegisteredTenantCreateOperation':
      return 'tenant'
    case 'TemplateCreateOperation': {
      return isTemplateCreateOperation(operation) &&
        isLibraryInOut(operation.entity)
        ? 'library'
        : 'template'
    }
    case 'TemplateHideOperation':
      return 'hideTemplate'
  }
}
